import { render, staticRenderFns } from "./PrimeiroAcesso.vue?vue&type=template&id=978ecf2e"
import script from "./PrimeiroAcesso.vue?vue&type=script&lang=js"
export * from "./PrimeiroAcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports